import React from 'react';
import { Link } from 'react-router';

import styles from './style.css';

class SuccessResetPassword extends React.Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-6 col-sm-offset-3">
            <div className={styles['box-success']}>
              <p className={`text-center ${styles.title}`}>
                Your password is updated!
              </p>
              <div className={`text-center ${styles['desc-title']}`}>
                Please click the button below and login with your new password
              </div>
              <p className="text-center">
                <Link
                  to="/login"
                  className={`btn btn-primary ${styles['btn-login']}`}
                >
                  Login
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SuccessResetPassword;
